var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscountCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99967 10.0002L9.77091 6.22893M14.6663 8.00016C14.6663 11.6821 11.6816 14.6668 7.99967 14.6668C4.31778 14.6668 1.33301 11.6821 1.33301 8.00016C1.33301 4.31826 4.31778 1.3335 7.99967 1.3335C11.6816 1.3335 14.6663 4.31826 14.6663 8.00016Z",
    stroke: "#1877F2",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33301 6.00016C5.33301 6.36835 5.63148 6.66683 5.99967 6.66683C6.36786 6.66683 6.66634 6.36835 6.66634 6.00016C6.66634 5.63197 6.36786 5.3335 5.99967 5.3335C5.63148 5.3335 5.33301 5.63197 5.33301 6.00016Z",
    fill: "#1877F2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33301 10.0002C9.33301 10.3684 9.63148 10.6668 9.99967 10.6668C10.3679 10.6668 10.6663 10.3684 10.6663 10.0002C10.6663 9.63197 10.3679 9.3335 9.99967 9.3335C9.63148 9.3335 9.33301 9.63197 9.33301 10.0002Z",
    fill: "#1877F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscountCircle);
export default __webpack_public_path__ + "static/media/discount-circle.17bc97d14d762fc9b818f55c80cff670.svg";
export { ForwardRef as ReactComponent };